import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HELPER from '../utils/Helper';
import translationEN from './en.json';
import translationID from './id.json';

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: HELPER.getLang(),
    compatibilityJSON: 'v3',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
